<template>
  <div
      v-show="workflow.id"
      class="workflow-main "
  >
    <div class="workflow-container flex">
      <process v-if="complete" :nodes="nodes"/>
      <div v-else>
        <div class="layout ">
          <div class="desc">必填信息填写后，流程将自动显示</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Message, MessageBox} from "@maidi/libs.pc";
import Process from "../../components/instance/process";
import {EInstanceState, InstanceService} from "@/views/components/instance/instance";
import {WorkflowProcess} from "@/views/components/workflow/workflow";
import {ApproveType, CompareType, ProcessType} from "@/views/components/workflow/process/process";
import {JsonService} from "@maidi/common";
import CacheService from "@/service/catch";


export default {
  name: "create",
  components: {Process},
  props: {
    processGroup: { // 1合同 2回款
      type: String,
      default: '1'
    },
    insId: {
      type: [String, Number]
    },
    defId: {
      type: [String, Number]
    },
    content: {
      type: [Object]
    }
  },
  data() {
    return {
      workflow: {},
      process: [],
      nodes: [],
      condition_fields: [],
      complete: false
    }
  },

  methods: {
    async load() {
      let workflow, wfId;
      if (this.defId) {
        wfId = this.defId
      } else {
        const onlyWf = await WorkflowProcess.list(true, 1, this.processGroup);
        if (!onlyWf || !onlyWf.length) {
          Message.warn(`当前企业没有启用${this.processGroup === '1' ? '合同' : '回款'}审批流程，请联系管理员`);
          return  this.back()
        }
        wfId = onlyWf[0].id;
      }


      workflow = await WorkflowProcess.get(wfId);
      if(!workflow){
         Message.warn(`当前${this.processGroup === '1' ? '合同' : '回款'}流程定义不存在，请重新发起申请`)
        return  this.back()
      }

      this.condition_fields.length = 0;
      const process = JSON.parse(workflow.processJson)
      process.forEach((node) => {
        if (node.type !== ProcessType.Condition || !node.content) {
          return;
        }
        node.content.forEach((condition) => {
          if (this.condition_fields.includes(condition.key)) {
            return;
          }
          this.condition_fields.push(condition.key);
        })
      });
      this.$set(this, "workflow", workflow);
      this.process.push(...process);
      !this.condition_fields.length && this.$refresh();

      this.loadInsInfo()
    },
    async loadInsInfo() {
      if (!this.insId) return
      let info = await InstanceService.info(this.insId);


      const groupId = info.steps[info.steps.length - 1].groupID;
      this.nodes.forEach((node, index) => {
        node.participants = info.steps.filter((step) => step.groupID === groupId && step.nodeSequence === index + 1).sort((step1, step2) => step1.sequence - step2.sequence).map((step) => {
          return {id: step.participant, name: step.participantName};
        });
      });
      this.$refresh();

    },
    $refresh() {
      this.complete = this.condition_fields.every((field) => {
        return this.content[field] != null && this.content[field] !== "";
      });
      if (!this.complete) {
        return;
      }
      let nodes = this.next();
      nodes = nodes.map((node) => {
        const exists = this.nodes.find((_node) => _node.id === node.id);
        return exists || {
          id: node.id,
          name: node.name,
          type: node.type,
          content: node.content,
          participants: node.participants,
        };
      });

      // 缺少功能：用户操作体验方面问题
      // this.change触发后会调用this.$refresh，造成nodes重新初始化的清空，要考虑之前node节点上已经选择了审批人
      // 如果再次修改条件之后，可能会造成之前被删除的节点重新添加时的问题，这个时候需要把上次的审批人赋给新添加的节点
      this.nodes.length = 0;
      nodes.forEach((node) => {
        if (node.content.type !== ApproveType.FormContacts) {
          return;
        }
        const contacts = this.content[node.content.form_contacts.key];
        node.participants = JsonService.clone([].concat(contacts || []));
      });
      this.nodes.push(...nodes);
    },
    next(prev, section) {
      const nodes = [];
      let node = this.process.filter((node) => node.prev === prev && node.section === section);
      if (!prev && section) {
        node.sort((node1, node2) => node1.order < node2.order ? -1 : 1);
        const condition = node.find((_node) => {
          if (!_node.content || !_node.content.length) {
            return true;
          }
          return _node.content.every((condition) => {
            const {compare, key, value} = condition;
            if (this.content[key] == null) {
              return false;
            }
            if (!compare)
              return value.includes(this.content[key]);
            const val = parseFloat(this.content[key]);
            switch (compare) {
              case CompareType.Less:
                return val < value;
              case CompareType.LessEqual:
                return val <= value;
              case CompareType.Greater:
                return val > value;
              case CompareType.GreaterEqual:
                return val >= value;
              case CompareType.Equal:
                return val == value;
              case CompareType.Between:
                return value[0] <= val && val <= value[1];
            }
          });
        });
        if (condition) {
          nodes.push(...this.next(condition.id, condition.section));
        }
        return nodes;
      }
      node = node[0];
      if (!node) {
        return nodes;
      } else if (node.type === ProcessType.Section) {
        nodes.push(...this.next(undefined, node.id));
      } else {
        nodes.push(node);
      }
      nodes.push(...this.next(node.id, node.section));
      return nodes;
    },
    back(){
      setTimeout(() => {
        this.$router.back();
      }, 500)
    },
    // 保存
    async submit(dataId) {
      try {
        const model = await this.$save(dataId);
        await Message.success(`流程提交成功!`);
      } catch (e) {
        !e.Message && Message.error(e.message || e);
      }
    },
    async $save(dataId) {
      if (!this.nodes.length) {
        throw new Error(`当前流程没有审批节点,请检查流程配置`);
      }
      const process = this.nodes.reduce((list, item, index) => {
        if (!item.participants || !item.participants.length) {
          const notify = item.type === ProcessType.Notify;
          throw new Error(`第${index + 1}级${notify ? "抄送" : "审批"}节点【${item.name}】未选择${notify ? "接收" : "处理"}人`);
        }
        const sequence = list.length ? list[list.length - 1].sequence : 0;
        const data = {
          nodeName: item.name
        };
        if (item.content && item.content.activate) {
          data.activate = item.content.activate;
        }
        list.push(...item.participants.map((participant, _index) => {
          return {
            ...data,
            id: 0,
            insID: this.insId || 0,
            participant: participant.id,
            participantName: participant.name,
            sequence: sequence + 1 + (data.activate === "one_by_one" ? _index : 0),
            nodeSequence: index + 1
          };
        }));
        return list;
      }, []);

      const user = CacheService.get("user");
      const model = {
        dataSource: this.processGroup,
        dataId,
        instanceDto: {
          id: this.insId || 0,
          defID: this.workflow.id,
          defName: this.workflow.name,
          title: `${user.realName}提交的${this.workflow.name}`,
          description: "",
          state: EInstanceState.Processing,
          steps: process
        }
      };
      if (this.insId) {
        Object.assign(model, {insID: this.insId});
      }

      return await InstanceService.save(model);

    }
  },
  mounted() {
    this.load();
  }
};
</script>

<style scoped lang="scss">
@import "../../../assets/css/global";

.workflow-header {
  height: 24px;
  background: #f5f1f1;
  border-radius: 2px;
}

.workflow-main {
  overflow: auto;
  background-color: #f1f1f1;
}

.workflow-container {
  background-color: #fff;
  padding-bottom: 20px;
  width: 100%;
  min-height: 100%;
  margin: 0 auto;
  overflow: hidden;

  .workflow-form {
    overflow: hidden;
    padding: 15px 15px 0 120px;
  }

  .workflow-footer {
    padding: 0 15px 15px 15px;
  }
}

$label-width: 100px;
.explain,
.desc {
  color: $color-font-light;
}

.workflow-form {
  .explain {
    font-size: 1.2rem;
  }

  .field-label {
    /*&:after {*/
    /*!*content: ":";*!*/
    /*!*display: inline-block;*!*/
    /*}*/
    &.required:before {
      content: "*";
      color: $color-error;
      padding-right: 3px;
      font-size: 16px;
      position: relative;
      top: 3px;
      display: inline-block;
    }
  }
}

.field {
  margin-top: 10px;
  margin-bottom: 10px;
  line-height: 30px;

  .field-label {
    //width: $label-width;
    text-align: right;
    padding-right: 10px;
  }
}

.button-save {
  width: 200px;
  border-radius: 0;
  margin-top: 20px;
  margin-left: $label-width;
}

//.workflow-process {
//  padding-left: $label-width;
//}

.field {
  .field-input {
    .ant-radio-group-item,
    .ant-checkbox-group-item {
      width: 80px;
    }
  }
}
</style>
